<template>
    <div class="text-input">
        <label v-if="label" class="text-input__label">{{ label }}<span v-if="optional" class="q-ml-xs" style="color: #858585; font-size: 9px; font-weight: normal; letter-spacing: 0.5px;"> (optional)</span></label>

        <input
            type="text"
            class="text-input__field"
            :placeholder="placeholder"
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
        />
    </div>
</template>

<script>
export default {
    name: "TextInput",

    props: {
        label: {
            type: String,
            default: "",
        },
        placeholder: {
            type: String,
            default: "",
        },
        modelValue: {
            type: String,
            default: "",
        },
        optional: {
            type: Boolean,
            default: false,
        },
    },

    emits: ["update:modelValue"],
};
</script>

<style scoped>
.text-input {
    position: relative;
    width: 100%;
    max-width: 100%;
    color: #080808;
    font-family: Arial, Helvetica, sans-serif;
}

.text-input__label {
    display: block;
    margin: 0 0 4px 2px;
    color: #5f5f5f;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 1px;
}

.text-input__field {
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    padding: 0 12px 0 12px;
    border: 1px solid #a8a8a8;
    border-radius: 8px;
    background: #ffffff;
    color: #080808;
    font: inherit;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    text-align: left;
    box-sizing: border-box;
}

.text-input__field::placeholder {
    color: #989898;
    font-weight: 500;
}

.text-input__field:focus {
    outline: 2px solid #ff4e00;
    outline-offset: 1.5px;
}
</style>
